// Contrato da API. Cálculos financeiros são feitos exclusivamente no backend.
export type IndicadoresDesempenho = { pedidos: number; faturamento: number; ticketMedio: number };
export type CanalDesempenho = 'projetos' | 'caixa' | 'comandas' | 'totem';
export type CustosDesempenho = {
  custo: number | null; lucroBruto: number | null; margem: number | null;
  itensComCusto: number; itensSemCusto: number; itensCustoLegado: number;
};
export type QualidadeDesempenho = { pagamentosEstimados: number; pagamentosInconsistentes: number };
export type ResultadoDesempenho = IndicadoresDesempenho & {
  versao: number;
  recebido: number; emAberto: number; recebidoAMais: number;
  pagamentos: Record<string, number>;
  custos: CustosDesempenho;
  qualidade: QualidadeDesempenho;
  porDia: { data: string; canais: Record<CanalDesempenho, { pedidos: number; faturamento: number }> }[];
};
export async function carregarDesempenho(baseUrl: string, loja: string, token: string, inicio: string, fim: string, signal?: AbortSignal): Promise<ResultadoDesempenho> {
  const query = new URLSearchParams({ loja, inicio, fim });
  const resposta = await fetch(`${baseUrl}/desempenho?${query}`, {
    method: 'GET', headers: { token }, credentials: 'include', signal,
  });
  if (!resposta.ok) throw new Error('Não foi possível carregar os indicadores');
  const dados = await resposta.json();
  const finito = (valor: unknown) => typeof valor === 'number' && Number.isFinite(valor);
  if (dados.versao !== 1 || ![dados.pedidos, dados.faturamento, dados.ticketMedio, dados.recebido, dados.emAberto, dados.recebidoAMais].every(finito)
    || !Array.isArray(dados.porDia) || !dados.pagamentos || !dados.custos || !dados.qualidade) {
    throw new Error('Indicadores indisponíveis');
  }
  return dados;
}
